export default {"src":"/_next/static/image/public/logos/oanda-icon.c2fc3bd4f29ab02658674195e8e99597.svg","height":94,"width":94};